



















































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    NavbarDark,
    Footer,
  },
})
export default class EresCandidato extends Vue {
  public isCandidate() {
    const isCandidate = this.$store.getters
      .getAreYouCandidate as boolean;
    const candidateInfo = this.$store.getters.getAreYouCandidateAnswers;

    if (isCandidate) {
      this.$store.dispatch('fireCandidates/insert', candidateInfo);
      this.$store.dispatch('sendAnswersEmail');
      this.$router.push('/si-eres-candidato');
    } else {
      this.$store.dispatch('fireNotCandidates/insert', candidateInfo);
      this.$store.dispatch('sendAnswersEmail');
      this.$router.push('/no-eres-candidato');
    }
  }

  public updateAreYouCandidate(event: any) {
    const attribute = event.target.id;
    const value = event.target.value;
    const currentAreYouCandidate = this.$store.getters
      .getAreYouCandidateAnswers;
    currentAreYouCandidate[attribute] = value;
    this.$store.commit('setShoppingCartStep', currentAreYouCandidate);
  }

  public updateAreYouCandidateUsedBraces(usedBraces: boolean) {
    this.$store.commit('setAreYouCandidateUsedBraces', usedBraces);
  }

  public updateAreYouCandidateRetainer(usesPermanentRetainer: boolean) {
    this.$store.commit('setAreYouCandidateUsesPermanentRetainer', usesPermanentRetainer);
  }

  public updateAreYouCandidateSpace(space: number) {
    this.$store.commit('setAreYouCandidateSpace', space);
  }

  public updateAreYouCandidateSplice(splice: number) {
    this.$store.commit('setAreYouCandidateSplice', splice);
  }

  public updateCurrentUserEmail(event: any) {
    const email = event.target.value;
    this.$store.commit('setCurrentUserEmail', email);
  }

  public updateCurrentUserName(event: any) {
    const name = event.target.value;
    this.$store.commit('setCurrentUserName', name);
  }

  public updateCurrentTelephone(event: any) {
    const phone = event.target.value;
    this.$store.commit('setCurrentTelephone', phone);
  }

  public validCandidate() {
    return this.$store.getters.getCandidateIsValid;
  }
}
